export default defineNuxtPlugin(() => {
  useCookiebot({}).consentBanner()

  return {
    provide: {
      cookieConsent: {
        configure: useCookiebot({}).renew,
        initialize: useCookiebot({}).consentBanner,
      },
    },
  }
})
